import React from 'react';
import { NO_PAGE_FEATURES, type PageFeatures, type PageKit } from './layouts/registry';

/**
 * The layout the shell is showing, for pages (docs/test-layouts.md, "Page features"). A test layout's
 * `features` switch on page content of its own and `kit` holds the components that render it; the public
 * layouts get no features and no kit, so their pages render exactly as before.
 */
export interface ShellLayoutValue {
  layout: string;
  features: PageFeatures;
  kit: PageKit | null;
}

export const PUBLIC_SHELL_LAYOUT: ShellLayoutValue = Object.freeze({ layout: 'classic', features: NO_PAGE_FEATURES, kit: null });

export const ShellLayoutContext = React.createContext<ShellLayoutValue>(PUBLIC_SHELL_LAYOUT);

export function useShellLayout(): ShellLayoutValue {
  return React.useContext(ShellLayoutContext);
}
